import isEmpty from 'lodash/isEmpty';
import React from 'react';

const uploadErrorsBeMapping: Record<number, string> = {
  1: 'File type not allowed',
  2: 'File name not valid',
  3: 'Operation ID not found',
  4: "It's not possible to upload files of already merged reports",
  5: 'File exceeds size limit',
  6: 'Server side error',
};

interface Props {
  errors?: Record<string, number[]>;
}

const ACRUploadNotificationError = ({ errors }: Props) => {
  return (
    <ul className="acr-multi-upload-errors-msg">
      <b>Errors on files upload:</b>
      {errors && !isEmpty(errors)
        ? Object.keys(errors).map(key => {
            if (!key) {
              return null;
            }

            return (
              <div key={key} className="acr-multi-upload-errors-msg-file">
                <div className="muem-title">{key} :</div>
                {key &&
                  Array.isArray(errors[key]) &&
                  errors[key].map(item => {
                    return <li key={item}>{uploadErrorsBeMapping?.[item]}</li>;
                  })}
                {key &&
                  Array.isArray(errors[key]) &&
                  errors[key].map(item => {
                    return <li key={item}>{uploadErrorsBeMapping?.[item]}</li>;
                  })}
              </div>
            );
          })
        : 'Error on file upload. Please retry later'}
    </ul>
  );
};

export default ACRUploadNotificationError;
